module.exports = __webpack_public_path__ + "img/people.f6fe6c3b.jpg";